var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-free-trial-detail"},[(_vm.reviewDetail)?_c('BoardDetail',{attrs:{"board-id":_vm.id,"board":_vm.reviewDetail,"list-path":"/reviews/free-trial"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }